module.exports = __webpack_public_path__ + "img/IMG_2479.11b2ff30.jpg";